// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:1024px){\n.links-footer__item{\n    display:inline\n}\n.links-footer__item+.links-footer__item{\n    margin-left:25px\n}\n}\n.links-footer__link{\n  color:#8094b0\n}\n.links-footer__link:focus{\n  color:#8094b0;\n  text-decoration:none\n}\n.links-footer__link:hover{\n  color:#617a9c;\n  text-decoration:none\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
